// 보기 전환 세그 (시안 .view) — 예: 표 | 카드. props: value, options:[{id,label}], onChange(id)
import React from 'react';
import { T } from '../theme';

var wrap = { display: 'inline-flex', border: '1px solid ' + T.bd, borderRadius: 7, overflow: 'hidden' };

function ViewToggle(props) {
  return (<span style={wrap} className="v2-view" role="group">
    {(props.options || []).map(function (o) {
      var on = o.id === props.value;
      return (<button key={o.id} type="button" aria-pressed={on} onClick={function () { if (props.onChange) props.onChange(o.id); }}
        style={{ padding: '0 10px', height: 28, display: 'inline-flex', alignItems: 'center', fontSize: 12, border: 'none', cursor: 'pointer', fontFamily: 'inherit',
          background: on ? T.bdSoft : T.card, color: on ? T.ink : T.muted, fontWeight: on ? 700 : 500 }}>{o.label}</button>);
    })}
  </span>);
}

export default ViewToggle;
